import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getProject } from '../../../apis/project-builder';
import { formatUnicorn } from "../../../../shared/utils";
import { useCurrentProjectIdContext, useTranslationContext } from "./project-builder-main.jsx";
import ProductsList from './products-list.jsx';
import ProductsListByFamily from './products-list-by-family.jsx';
import ProductsListHeader from './products-list-header.jsx';
import ProductNotesList from './product-notes-list.jsx';
import AttachmentsList from './attachments-list.jsx';
import animatedScrollTo from 'animated-scroll-to';
import Sidebar from './sidebar.jsx';
import DownloadsButtons from './downloads-buttons.jsx';
import { formatCurrency } from './utilities.jsx';

export default function ReceivedQuote({ expandAll, setExpandAll }) {

    const { currentProjectId } = useCurrentProjectIdContext();

    const { data, isSuccess, isLoading } = useQuery(['project-detail', currentProjectId], () => getProject(currentProjectId));

    const {translations} = useTranslationContext();

    const handleSectionLinkClick = (e) => {
        let href = e.target.getAttribute("href");
        let section = document.querySelector(href);
        animatedScrollTo(section);
    }

    return (
        <div className="project-builder project-builder-received-quote">
            {isSuccess ?
                <>
                    <div className="container received-quote-header">
                        <div className="downloads-container">
                            <div className='section-title'>{data.name}</div>
                            <div className="hide-mobile ml-auto">
                                <DownloadsButtons guid={data.guid} projectName={data.name} projectId={data.id} isMarketingProject={data.isMarketingProject} />
                            </div>
                        </div>
                        <div className="section-links">
                            <ul>
                                <li><a href="#quote-information" onClick={handleSectionLinkClick}>{translations.Information}</a></li>
                                <li><a href="#quote-products" onClick={handleSectionLinkClick}>{translations.Products}</a></li>
                                <li><a href="#quote-attachments" onClick={handleSectionLinkClick}>{translations.Attachments}</a></li>
                                <li><a href="#quote-project-notes" onClick={handleSectionLinkClick}>{translations.ProjectNotes}</a></li>
                                <li><a href="#quote-product-notes" onClick={handleSectionLinkClick}>{translations.ProductNotes}</a></li>
                            </ul>
                        </div>

                        <div className="mobile-downloads-container">
                            <hr />
                            <DownloadsButtons guid={data.guid} projectName={data.name} projectId={data.id} isMarketingProject={data.isMarketingProject} />
                        </div>
                    </div >
                    <hr />
                    <div className="container section equal-margin">
                        <div className="row review-quote-content">
                            <div className="col-lg-8">
                                <div id="quote-information" className="added-section added-information">
                                    <div className="section-header">
                                        <div className="section-number">1</div>
                                        <div className="section-title">{translations.Information}</div>
                                        <div className="quote-details">
                                            <ul>

                                                <li>{translations.AccountName}: <span>{data.accountName}</span></li>
                                                <li>{translations.ZipCode}: <span>{data.zipCode}</span></li>
                                                <li>{translations.CreatedBy}: <span>{data.createdBy}</span></li>
                                                <li>{translations.ContactEmailAddress}: <span>{data.contactEmailAddress}</span></li>
                                                <li>{translations.ContactPhoneNumber}: <span>{data.contactPhoneNumber}</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div id="quote-project-header" className="added-section added-information">
                                    <div className="section-header section-header--borderTop">
                                        <div className="section-number">2</div>
                                        <div className="section-title">{translations.ProjectHeader}</div>
                                    </div>
                                    <div className="rounded-border rounded-border--paddingSmall">
                                        <p>{data.headerText}</p>
                                    </div>
                                </div>

                                <div id="quote-products" className="added-section added-products">
                                    <div className="section-header">
                                        <div className="section-number">3</div>
                                        <div className="section-title mr-auto">{translations.Products}</div>
                                        {(data.products.length > 0) &&
                                            <ProductsListHeader
                                                expandAll={expandAll}
                                                setExpandAll={setExpandAll}
                                                reviewList
                                            />
                                        }
                                    </div>

                                    {(data.sortType == "ProductFamilyGrouping" || data.sortType == "CustomGrouping")
                                        ? <div className="rounded-border rounded-border--noPadding"><ProductsListByFamily expandAll={expandAll} reviewList readOnly /></div>
                                        : <div className="rounded-border"><ProductsList reviewList readOnly /></div>
                                    }
                                </div>

                                <div id="quote-attachments" className="added-section added-attachments">
                                    <div className="section-header">
                                        <div className="section-number">4</div>
                                        <div className="section-title">{translations.Attachments}</div>
                                    </div>
                                    <div className="section-subtitle">{translations.Documents}</div>
                                    <div className="rounded-border mb-1">
                                        <AttachmentsList
                                            readOnly
                                            collapsedText={formatUnicorn(translations.ShowAll, translations.Documents)}
                                            expandedText={formatUnicorn(translations.ShowLess, translations.Documents)}
                                            recommendedAttachments={data.attachements.filter((attachment) => attachment.isDocument)}
                                        />
                                    </div>

                                    <div className="section-subtitle">{translations.Videos}</div>
                                    <div className="rounded-border rounded-border--paddingSmall">
                                        <AttachmentsList
                                            readOnly
                                            collapsedText={formatUnicorn(translations.ShowAll, translations.Videos)}
                                            expandedText={formatUnicorn(translations.ShowLess, translations.Videos)}
                                            recommendedAttachments={data.attachements.filter((attachment) => attachment.isVideo)}
                                        />
                                    </div>
                                </div>

                                <div id="quote-project-notes" className="added-section added-information">
                                    <div className="section-header">
                                        <div className="section-number">5</div>
                                        <div className="section-title">{translations.ProjectNotes}</div>
                                    </div>
                                    <div className="rounded-border rounded-border--paddingSmall">
                                        <p>{data.notes}</p>
                                    </div>
                                </div>

                                <div id="quote-product-notes" className="added-section added-information">
                                    <div className="section-header">
                                        <div className="section-number">6</div>
                                        <div className="section-title">{translations.ProductNotes}</div>
                                    </div>
                                    <div className="rounded-border rounded-border--paddingSmall">
                                        <ProductNotesList />
                                    </div>
                                </div>




                                {data.isMarketingProject ?
                                    null :
                                    <>
                                        <div className="quote-price condensed-view-only"><span>{translations.ProductTotal.toUpperCase()}:</span> {formatCurrency(data.totalProductPrice)}</div>
                                        <div className="rounded-border mt-2">
                                            <div className="send-quote-card">
                                                <div className="send-quote-card-content ml-0">
                                                    <div className="quote-price"><span>{translations.QuotePrice.toUpperCase()}:</span> {formatCurrency(data.totalNetPrice)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>

                            <Sidebar received />
                        </div>

                        <div id="signature-section">
                            <h2>{translations.ThankYouMessage}</h2>
                            <br />
                            <div className="contact-information">
                                <p>{data.salesRep?.firstName} {data.salesRep?.lastName}</p>
                                <p>{data.salesRep?.position}</p>
                                <p>{data.salesRep?.phoneNumber}</p>
                                {data.salesRep?.email &&
                                    <p>
                                        <a href={`mailto:${data.salesRep.email}`}>{data.salesRep.email}</a>
                                    </p>
                                }
                            </div>
                            <br />
                            <br />
                            <div id="signature-footer">
                                <div>
                                    <span>{translations.Acceptance}:___________________________________</span> <span>{translations.Date}:____________________</span>
                                </div>
                                <br /><br />
                                <div>{translations.PrintedName}:__________________________________</div>
                            </div>
                        </div>

                        <div id="footer-signature-section">
                            <div>
                                <div className="title" style={{ fontWeight: 'bold', color:'#666666'}}>{data.name}</div>
                                <div>{translations.CreatedBy}: {data.createdBy}</div>
                                <div>{data.accountName}</div>
                                <div>{data.contactEmailAddress}</div>
                                <div>{data.contactPhoneNumber}</div>
                            </div>
                        </div>

                    </div>
                </>
                : null
            }
        </div >
    );
}